export default __webpack_public_path__ + "static/media/ghaidaa.0d765492.jpg";